import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import {
  SevereWeatherNotificationService,
  SevereWeatherAlert,
} from '../../../services/severe-weather-notification.service';

@Component({
  selector: 'app-severe-weather-banner',
  templateUrl: './severe-weather-banner.component.html',
  styleUrls: ['./severe-weather-banner.component.scss'],
  animations: [
    trigger('slideDown', [
      state('visible', style({ transform: 'translateY(0)', opacity: 1 })),
      state('hidden', style({ transform: 'translateY(-100%)', opacity: 0 })),
      transition('hidden => visible', animate('300ms ease-out')),
      transition('visible => hidden', animate('300ms ease-in')),
    ]),
  ],
})
export class SevereWeatherBannerComponent implements OnInit, OnDestroy {
  currentAlert: SevereWeatherAlert | null = null;
  private destroy$ = new Subject<void>();

  constructor(private severeWeatherService: SevereWeatherNotificationService) {}

  ngOnInit(): void {
    this.severeWeatherService.currentAlert$
      .pipe(takeUntil(this.destroy$))
      .subscribe(alert => {
        this.currentAlert = alert;
      });
  }

  get animationState(): string {
    return this.currentAlert?.isVisible ? 'visible' : 'hidden';
  }

  onDismiss(): void {
    this.severeWeatherService.dismiss();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
